export const URL = {
  GET_ANTIFORGERY_PREPARE: `${API_URL}/antiforgery`,
  GET_ANTIFORGERY_TOKEN: `${API_URL}/antiforgery/token`,
  POST_LOGIN: `${API_URL}/auth/signin`,
  POST_JWT_REFRESH: `${API_URL}/auth/refreshToken`,
  POST_FORGOT_PASSWORD: `${API_URL}/auth/forgotpassword`,
  POST_RESET_PASSWORD: `${API_URL}/auth/resetpassword`,
  GET_ACCOUNT_DETAILS: `${API_URL}/me`,

  GET_USERS_LIST: `${API_URL}/users`,
  GET_ROLES_LIST: `${API_URL}/users/roles`,
  GET_USER: `${API_URL}/users/{id}`,
  POST_USER: `${API_URL}/users`,
  PUT_USER: `${API_URL}/users/{id}`,
  DELETE_USER: `${API_URL}/users/{id}`,

  GET_CUSTOMERS_LIST: `${API_URL}/customers`,
  GET_CUSTOMER: `${API_URL}/customers/{id}`,
  POST_CUSTOMER: `${API_URL}/customers`,
  PUT_CUSTOMER: `${API_URL}/customers/{id}`,
  PUT_CUSTOMER_SECRET_KEY: `${API_URL}/customers/{id}/generate/key`,
  DELETE_CUSTOMER: `${API_URL}/customers/{id}`,

  GET_DEVICES_LIST: `${API_URL}/devices/list`,
  GET_DEVICES_SEARCH: `${API_URL}/devices/search`,
  GET_DEVICE_STATUS: `${API_URL}/devices/status`,
  GET_DEVICES_COUNT: `${API_URL}/devices/count`,
  GET_DEVICE: `${API_URL}/devices/{serial}`,
  POST_DEVICE: `${API_URL}/devices`,
  PUT_DEVICE: `${API_URL}/devices/{serial}`,
  DELETE_DEVICE: `${API_URL}/devices/{serial}`,
  PATCH_DEVICE_RESTORE: `${API_URL}/devices/{serial}`,

  GET_DEVICE_CONTENT: `${API_URL}/devices/{serial}/content`,

  GET_DEVICE_CONTENT_URL: `${API_URL}/devices/content/{contentId}`,
  POST_DEVICE_STATUS: `${API_URL}/devices/status`,

  POST_VIDEO_SEARCH: `${API_URL}/video/search`,
  POST_VIDEO_LIVE: `${API_URL}/video/live`,
  POST_VIDEO_DOWNLOAD: `${API_URL}/video/download`,

  POST_SNAPSHOT: `${API_URL}/snapshot`,

  POST_XML_FILE: `${API_URL}/config/pushXml`,
  GET_XML_FILE: `${API_URL}/config/getXml`,

};

export const getUrl = (template, params = {}) => {
  Object.keys(params).forEach(key => {
    template = template.replace(`{${key}}`, params[key]);
  });
  return template;
};



// WEBPACK FOOTER //
// ./src/api/constants.js